import type React from "react";
import { type ReactNode, useEffect } from "react";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";

interface BlinkingProps {
  children: ReactNode;
  fadeTo?: number;
  duration?: number;
}

const Blinking: React.FC<BlinkingProps> = ({
  children,
  fadeTo = 0.2,
  duration = 1000,
}) => {
  const opacity = useSharedValue(1);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    };
  });

  useEffect(() => {
    // Animate opacity between 1 and fadeTo in intervals
    opacity.value = withRepeat(
      withTiming(fadeTo, { duration }),
      -1, // Infinite repeats
      true, // Reverse the animation (fades back in)
    );
  }, [opacity, fadeTo, duration]);

  return <Animated.View style={animatedStyle}>{children}</Animated.View>;
};

export default Blinking;
